import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import api from "../lib/api";
import { AUTH_TEXT, authInputCls, authLabelCls, authBtnCls } from "../components/auth/authText";

export default function ResetPassword() {
  const { lang } = useLang();
  const tx = AUTH_TEXT[lang] || AUTH_TEXT.en;
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError(tx.tooShort);
    if (password !== confirm) return setError(tx.mismatch);
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.status === 400 ? tx.badLink : err.response?.status === 429 ? tx.tooMany : tx.genericError);
    } finally {
      setLoading(false);
    }
  };

  if (done || !token) {
    return (
      <div className="max-w-md mx-auto px-5 py-24 md:py-32 text-center" data-testid="reset-password-page">
        <h1 className="serif text-4xl mb-8">{done ? tx.doneTitle : tx.resetTitle}</h1>
        <p className="text-sm text-[#C9C2B8] leading-7" data-testid={done ? "reset-password-success" : "reset-password-missing-token"}>
          {done ? tx.doneSub : tx.badLink}
        </p>
        <Link to={done ? "/login" : "/forgot-password"} data-testid="reset-password-next-link" className={`${authBtnCls} inline-block mt-10`}>
          {done ? tx.goLogin : tx.sendLink}
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-5 py-24 md:py-32" data-testid="reset-password-page">
      <h1 className="serif text-4xl text-center mb-12">{tx.resetTitle}</h1>
      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className={authLabelCls}>{tx.newPassword}</label>
          <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" className={authInputCls} />
        </div>
        <div>
          <label className={authLabelCls}>{tx.confirmPassword}</label>
          <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-password-confirm-input" className={authInputCls} />
        </div>
        {error && <p className="text-sm text-[#E5484D]" data-testid="reset-password-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="reset-password-submit-button" className={authBtnCls}>
          {loading ? "…" : tx.savePassword}
        </button>
      </form>
    </div>
  );
}
